@if (visible) {
  <div [formGroup]="element.group"
    class="has-float-label"
    [ngClass]="element?.theme?.outerWrap"
    >
    <select [id]="id"
      class="form-control"
      [ngClass]="element?.theme?.control"
      [compareWith]="compareSelectValues"
      [formControlName]="element.name">
      @for (option of values; track option) {
        <option
          [ngValue]="option.value"
          [disabled]="option.disabled"
          [hidden]="option.hidden">
          {{ option.label | translate }}
        </option>
      }
    </select>
    @if ((element.elementOptions.label | translate)) {
      <label
        [ngClass]="element?.theme?.labelClass"
        [for]="id">
        {{ element.elementOptions.label | translate }}
        @if (element?.tooltip?.display) {
          <span>
            <i class="fa fa-question-circle"
              aria-hidden="true"
              placement="{{element.tooltip.placement || 'right'}}"
            ngbTooltip="{{element.tooltip.text}}"></i>
          </span>
        }
      </label>
    }
    <div class="input-err text-danger">
      @if (element?.group?.controls[element.name]?.touched && error) {
        <span
        attr.data-test="{{element?.name}}-error">{{ error | translate }}</span>
      }
    </div>
  </div>
}
